import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { track } from "@/lib/analytics";
import { useIsMobile } from "@/hooks/use-mobile";

export function FloatingWhatsAppButton() {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  const whatsappUrl = "https://wa.me/31617105786?text=Hallo%20SOL-VI%2C%20ik%20heb%20interesse%20in%20jullie%20duurzame%20energieoplossingen";

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-40"
      onClick={() => track("floating_whatsapp_click")}
    >
      <Button
        size="icon"
        className="h-14 w-14 rounded-full bg-green-600 hover:bg-green-700 shadow-energy text-white"
      >
        <MessageCircle className="h-6 w-6" />
        <span className="sr-only">WhatsApp contact: 06 17 10 57 86</span>
      </Button>
    </a>
  );
}